<template>
    <div class="product-details-wrap bg-slate-50 p-1" style="  ">
        <div class="flex flex-col is-justify-content-space-between"> 
            <!-- <span class="is-pulled-left"> Info </span> -->
            <div class="is-size-5">
                <small class="is-size-7">{{selected_item.brand_name}}</small>
                <p style="margin-top:-10px;" class="is-size-6">
                    {{selected_item.name}}
                </p>
            </div>
            <small class="text-slate-400 text-10px mr-2"># {{selected_item.code}}</small>
            <div class="mt-2 flex items-center gap-2 flex-wrap">
                <a
                    v-if="selected_item.guid"
                    href="#"
                    class="button is-small is-teal"
                    :class="{ 'is-loading': labelExportLoading }"
                    @click.prevent="openLabelModal"
                >
                    <i class="fa fa-file-pdf mr-1"></i> Eksporto etiketën (PDF)
                </a>
                <a
                    v-if="selected_item.guid || selected_item.id"
                    href="#"
                    class="button is-small is-info"
                    :class="{ 'is-loading': resyncLoading }"
                    title="Dërgo të gjitha fushat në Financa 1 dhe Financa 2 (PATCH, ose POST nëse artikulli mungon)"
                    @click.prevent="resyncFinanca"
                >
                    <i class="fa fa-refresh mr-1"></i> Sinkronizo Financa
                </a>
                <span v-if="selected_item.fis_status === 1" class="inline-flex items-center gap-1 px-2 py-0.5 rounded text-xs font-medium bg-green-100 text-green-800" title="U ruajt në Financa 1 dhe Financa 2">
                    <i class="fa fa-check-circle text-green-600"></i> U ruajt në Financa 1 dhe Financa 2
                </span>
                <span v-else class="inline-flex items-center gap-1 px-2 py-0.5 rounded text-xs font-medium bg-amber-100 text-amber-800" title="Jo ruajtur/sinkronizuar me F5">
                    <i class="fa fa-exclamation-circle text-amber-600"></i> Jo ruajtur/sinkronizuar me F5
                </span>
            </div>
        </div>
        <div class="mb-4 is-size-7">
            <div class="is-flex is-justify-content-space-between mb-1 border-b-2 border-slate-100">
                <div v-if="selected_item.type_id">
                    <small class="text-slate-400">Kategoria</small> 
                    <p v-if="selected_item.categories.length > 0" v-html="selected_item.categories.map(
                        (v, index) => { 
                            if(index == 0) return '<b>'+v.name.toUpperCase()+'</b>'
                            return v.name.toUpperCase() 
                        }).reverse().join(' > ')">
                    </p>
                    <p v-else class="has-text-danger">
                        <small> Nuk ka kategori </small>
                    </p>
                </div>
                <!-- <div v-if="selected_item.code" class="has-text-right">
                    <small class="text-slate-400">Kodi</small> 
                    <p># {{selected_item.code}}</p>
                </div> -->
            </div>
            <div v-if="selected_item.description" class="border-b-2 border-slate-100">
                <small class="text-slate-400">Pershkrimi</small> 
                <p>{{selected_item.description}}</p>
            </div>
            <div  class="is-flex is-justify-content-space-between mb-1 border-b-2 border-slate-100">
                <div v-if="selected_item.unit_name" class="">
                    <small class="text-slate-400">Njesia</small>
                    <p>{{selected_item.unit_name}}</p>
                </div>
                <!-- <div v-if="selected_item.brand_name" class=" has-text-right">
                    <small class="text-slate-400">Marka</small>
                    <p>{{selected_item.brand_name}}</p>
                </div> -->
            </div>
            <div v-if="selected_item.attributes.length > 0" class="border-b-2 border-slate-100 mt-2">
                <!-- <small class="text-slate-400">Atribute</small> -->
                <table v-if="selected_item.attributes.length > 0" class="table is-striped is-hoverable is-fullwidth is-narrow is-bordered is-size-7">
                    <thead>
                        <tr style="background: #ecf9ff;">
                            <th width="20%" class="font-thin has-text-grey">Specifika</th>
                            <th class="font-thin has-text-grey">Vlera</th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr v-for="(attribute, index) in selected_item.attributes" :key="index">
                            <td >{{attribute.attribute_name}}</td>
                            <td>
                                <strong v-if="!isCheckboxAttribute(attribute)" >
                                    {{ displayAttributeValue(attribute) }}
                                </strong>
                                <span v-else>
                                    <i v-if="isCheckboxYes(attribute)" class="fa-regular fa-square-check"></i>
                                    <i v-else class="fa-regular fa-square-full"></i>
                                </span>
                            </td>
                        </tr>
                    </tbody>
                </table>
            </div>

            <div v-if="selected_item.accessories.length > 0" class="border-b-2 border-slate-100 my-2">
                <p class="text-slate-400 px-2" style="background:#ecf9ff; color:#000; ">Aksesore</p>
                <div class="pl-4">
                    <div v-for="(category, index) in selected_item.accessories_categories" :key="index">
                        <p style="font-size:10px;">{{category.accessory_name}}</p>
                        <div v-for="(accessory, indexa) in selected_item.accessories.filter(a => a.accessory_id == category.accessory_id)" :key="indexa"
                            class="ml-2 mb-2">
                            <span>
                                {{accessory.name}}
                            </span>
                        </div>
                    </div>
                </div>
            </div>
            <div class="mt-2 border">
                <p class="text-slate-400 px-2 py-1" style="background:#ecf9ff; color:#000; ">Sherbime</p>
                <div class="pl-4">
                    <table class="table is-fullwidth">
                        <thead>
                            <tr class="text-slate-200">
                                <td class="text-slate-200">Kategoria</td>
                                <td class="text-slate-200">Sherbimi</td>
                                <td class="text-slate-200">Cmimi</td>
                            </tr>
                        </thead>
                        <tbody>
                            <tr v-for="service in selected_item.services" :key="service.guid">
                                <td>{{service.category_name}}</td>
                                <td>{{service.service_name}}</td>
                                <td>{{ price_filter(service.service_price) }}</td>
                            </tr>
                        </tbody>
                    </table>
                </div>
            </div>
        </div>
        <!-- unit_name, brand_name transportanle_service_name, mountable_service_name,  -->
        <small>
            <!-- <pre> {{attributes_per_item}} </pre> -->
        </small>

        <LabelExportModal
            :open="showLabelModal"
            :loading="labelExportLoading"
            :export-context="labelExportContext"
            title="Eksporto etiketën (PDF)"
            :subtitle="selected_item.code ? ('Produkti: <strong>' + selected_item.code + '</strong>') : ''"
            @close="closeLabelModal"
            @confirm="confirmExportLabel"
        />
    </div>
</template>

<script>
var numeral = require('numeral');
import ProductsServices from "@/services/Product";
import { financaTargetsFailureText } from "@/utils/financaSaveNotice";
import LabelExportModal from "@/components/LabelExportModal.vue";

export default {
    props: ['selected_item', 'attributes_per_item'],
    components: { LabelExportModal },
    data() {
        return {
            labelExportLoading: false,
            showLabelModal: false,
            resyncLoading: false,
        };
    },
    computed: {
        labelExportContext() {
            const guid = this.selected_item?.guid;
            return {
                product_guids: guid ? [guid] : [],
                category_guid: null,
                related_entity: "products",
                include_descendants: false,
            };
        },
    },
    methods: {
        price_filter(price) {
            return numeral(price).format('0,0.00') + ' Lek'
        },
        isCheckboxAttribute(attribute) {
            const t = String(attribute?.input_type || attribute?.type_id || "").toLowerCase();
            return t === "checkbox";
        },
        isCheckboxYes(attribute) {
            const v = String(attribute?.attribute_value ?? "").trim().toLowerCase();
            return ["1", "true", "po", "yes"].includes(v);
        },
        displayAttributeValue(attribute) {
            const raw = attribute?.attribute_value;
            if (raw == null || raw === "") return "";
            return String(raw).toUpperCase();
        },
        openLabelModal() {
            if (!this.selected_item?.guid) return;
            this.showLabelModal = true;
        },
        closeLabelModal() {
            if (this.labelExportLoading) return;
            this.showLabelModal = false;
        },
        async confirmExportLabel({ per_page }) {
            if (!this.selected_item?.guid) return;
            this.labelExportLoading = true;
            try {
                await ProductsServices.exportLabels({
                    product_guids: [this.selected_item.guid],
                    per_page,
                });
                if (this.$toast) this.$toast.success('PDF i etiketave u shkarkua.');
                this.showLabelModal = false;
            } catch (e) {
                if (this.$toast) this.$toast.error(e?.message || 'Nuk u shkarkua PDF i etiketave.');
            } finally {
                this.labelExportLoading = false;
            }
        },
        async resyncFinanca() {
            const id = Number(this.selected_item?.id);
            const guid = this.selected_item?.guid;
            if (!id && !guid) return;
            this.resyncLoading = true;
            try {
                const res = await ProductsServices.resyncFinanca(
                    id
                        ? { product_ids: [id], source: "product_details" }
                        : { guids: [guid], source: "product_details" }
                );
                const ok = Number(res?.synced_ok || 0);
                const fail = Number(res?.synced_failed || 0);
                if (fail > 0) {
                    if (this.$toast) this.$toast.error(financaTargetsFailureText(res?.failed_sync));
                } else {
                    if (this.$toast) this.$toast.success(`U ruajt ${ok || 1} produkt në Financa 1 dhe Financa 2.`);
                }
                this.$emit("resynced", { ...res, fis_status: fail > 0 ? 0 : 1 });
            } catch (e) {
                if (this.$toast) this.$toast.error(e?.response?.data?.message || e?.message || "Nuk u sinkronizua në Financa.");
            } finally {
                this.resyncLoading = false;
            }
        },
    },
}
</script>

<style>
    .product-details-wrap *{
        font-family: 'Varela', san-serif, FontAwesome; 
    }
</style>
